var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"vel-icon",class:[
    _vm.iconName,
    {'vel-icon-primary':_vm.type==='primary'},
    {'vel-icon-success':_vm.type==='success'},
    {'vel-icon-info':_vm.type==='info'},
    {'vel-icon-warning':_vm.type==='warning'},
    {'vel-icon-danger':_vm.type==='danger'},
]},[_vm._v(_vm._s(_vm.iconText))])
}
var staticRenderFns = []

export { render, staticRenderFns }